"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Report_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Report = void 0;
const decorators_1 = require("./decorators");
const pile_class_1 = require("./pile.class");
const regex_1 = require("./regex");
const sector_class_1 = require("./sector.class");
const util_1 = require("./util");
function mapVolumes(array) {
    const total = array.map((r) => {
        return r.volume;
    }).reduce(util_1.sum, 0);
    const transported = array.filter((r) => {
        return r.status == 'transported';
    }).map((r) => {
        return r.volume;
    }).reduce(util_1.sum, 0);
    const live = total - transported;
    return { total, transported, live };
}
let Report = Report_1 = class Report {
    constructor(_doc) {
        this._doc = _doc;
        this.sector = new sector_class_1.Sector(this._doc.sector);
        this.piles = this._doc.piles.map((d) => new pile_class_1.Pile(d));
        this.generated = new Date(_doc.generated);
    }
    static create(_sectorDoc, _pileDocs) {
        const generated = new Date();
        const generatedTime = generated.getTime();
        const reportDoc = {
            _id: `r:${generatedTime}:${_sectorDoc._id}`,
            sector: _sectorDoc,
            piles: _pileDocs,
            generated: generated.toISOString()
        };
        return new Report_1(reportDoc);
    }
    get _measuredPiles() {
        return this.piles.filter((p) => {
            return p.hasMeasures && p.volume !== null && p.essence && p.essence.code;
        });
    }
    get uid() {
        return this._doc._id;
    }
    set uid(value) {
        if (!regex_1.reportKeyRegex.test(value)) {
            throw new Error(`${value} is not a valid ReportUID`);
        }
        this._doc._id = value;
    }
    get id() {
        const match = this._doc._id.match(regex_1.reportNumberRegex);
        return match ? Number(match[1]) : null;
    }
    get roads() {
        return this._measuredPiles.map(p => p.road).filter(util_1.uniqueValues);
    }
    get teams() {
        return this._measuredPiles.map(p => p.team).filter(util_1.uniqueValues);
    }
    get operations() {
        return this.sector.operations;
    }
    get essences() {
        return this._measuredPiles.map(p => p.essence.code).filter(util_1.uniqueValues);
    }
    get rows() {
        return this._measuredPiles.map((p) => {
            return {
                sector: this.sector.name,
                pile: p.id,
                foreman: p.foreman || 'anonymous',
                essence: p.essence.code,
                logLength: p.logLength,
                height: p.height,
                road: p.road,
                length: 1 * p.length,
                status: p.status,
                volume: p.volume
            };
        });
    }
    get totalVolume() {
        return this._measuredPiles.map(p => p.volume).reduce(util_1.sum, 0);
    }
    get transportedVolume() {
        return this._measuredPiles.filter(p => p.status == 'transported').map(p => p.volume).reduce(util_1.sum, 0);
    }
    get fieldVolume() {
        return this.totalVolume - this.transportedVolume;
    }
    get volumePerEssence() {
        const grouped = util_1.groupObjectsByProperty(this._measuredPiles, 'essenceCode');
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return result;
    }
    get volumePerTeam() {
        const grouped = util_1.groupObjectsByProperty(this._measuredPiles, 'team');
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return result;
    }
    get volumePerRoad() {
        const grouped = util_1.groupObjectsByProperty(this._measuredPiles, 'road');
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return result;
    }
    get volumePerTeamPerEssence() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['team', 'essenceCode']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return util_1.fillObjectKeys(result, 2, 0);
    }
    get volumePerRoadPerEssence() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['road', 'essenceCode']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return util_1.fillObjectKeys(result, 2, 0);
    }
    get volumePerTeamPerRoadPerEssence() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['team', 'road', 'essenceCode']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
            // return array.map((r: any) => {
            //   return r.volume;
            // }).reduce(sum);
        });
        return util_1.fillObjectKeys(result, 3, 0);
    }
    get volumePerRoadPerTeamPerEssence() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['road', 'team', 'essenceCode']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return util_1.fillObjectKeys(result, 3, 0);
    }
    get volumePerTeamPerRoad() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['team', 'road']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return util_1.fillObjectKeys(result, 2, 0);
    }
    get volumePerRoadPerTeam() {
        const grouped = util_1.groupObjectsByProperties(this._measuredPiles, ['road', 'team']);
        const result = util_1.forEachArrayInObject(grouped, (array) => {
            return mapVolumes(array);
        });
        return util_1.fillObjectKeys(result, 2, 0);
    }
    toDoc() {
        return Object.assign({
            _id: `r:${new Date(this.generated).getTime()}:${this.sector.uid}`,
            sector: this.sector.toDoc(),
            piles: this.piles.map(p => p.toDoc())
        }, this.toJSON(), {
            generated: this.generated.toISOString()
        });
    }
    toJSON() {
        var _a;
        const jsonObj = {};
        // add all properties
        const proto = Object.getPrototypeOf(this);
        for (const key of Object.keys(proto)) {
            const desc = Object.getOwnPropertyDescriptor(proto, key);
            const hasGetter = desc && typeof desc.get === 'function';
            if (hasGetter) {
                jsonObj[key] = (_a = desc === null || desc === void 0 ? void 0 : desc.get) === null || _a === void 0 ? void 0 : _a.call(this);
            }
        }
        return jsonObj;
    }
};
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "_measuredPiles", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Report.prototype, "uid", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "id", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Report.prototype, "roads", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Report.prototype, "teams", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Report.prototype, "operations", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Report.prototype, "essences", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Report.prototype, "rows", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "totalVolume", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "transportedVolume", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "fieldVolume", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerEssence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerTeam", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerRoad", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerTeamPerEssence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerRoadPerEssence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerTeamPerRoadPerEssence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerRoadPerTeamPerEssence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerTeamPerRoad", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Report.prototype, "volumePerRoadPerTeam", null);
Report = Report_1 = __decorate([
    decorators_1.Sealed(),
    __metadata("design:paramtypes", [Object])
], Report);
exports.Report = Report;
